import React from "react";
import { Flex } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContextProvider";

const Navbar = () => {
  const { token, logoutUser } = React.useContext(AuthContext);
  return (
    <Flex
      justifyContent={"space-evenly"}
      backgroundColor={"#55A21B"}
      padding={"20px"}
    >
      <Link to="/">Home</Link>
      {token ? (
        <Link onClick={logoutUser}>Logout</Link>
      ) : (
        <Link to={"/login"}>Login</Link>
      )}
      {token ? (
        <Link to={"/recipecrud"}>Crud Operations</Link>
      ) : (
        <Link to={"/register"}>Register</Link>
      )}
      <Link to={"/recipes"}>Recipes</Link>
    </Flex>
  );
};

export default Navbar;
